<xemex-card
  [title]="'home.devicesWidget.title' | translate"
  titleSize="lg"
  [actionLabel]="'home.viewAll' | translate"
  (action)="viewAll.emit()"
>
  <div class="flex items-center gap-10 py-6" data-testid="donut-devices">
    <xemex-donut-chart
      [segments]="segments()"
      [size]="200"
      [thickness]="18"
      [centerLabel]="centerLabel()"
      [centerSubLabel]="
        installedTotal()
          ? ('home.devicesWidget.onlineOf' | translate: { total: installedTotal() })
          : ''
      "
      [interactive]="true"
      [showTooltip]="true"
      [hoveredLabel]="highlighted()"
      (segmentHover)="hovered.set($event)"
      (segmentClick)="segmentFilterClick.emit($event)"
    ></xemex-donut-chart>
    <div class="flex min-w-0 flex-1 flex-col gap-1">
      @for (group of groups(); track group.key; let first = $first) {
        @if (!first) {
          <hr class="my-2 border-t" data-testid="legend-divider" />
        }
        <div
          class="flex items-center px-2 pb-1 text-sm font-bold uppercase tracking-wider text-text-muted"
          [attr.data-testid]="'legend-group-' + group.key"
          (mouseenter)="hoveredGroup.set(groupLabels(group))"
          (mouseleave)="hoveredGroup.set(null)"
        >
          <span class="flex-1">{{ group.key | translate }}</span>
          <span class="text-xl">{{ group.total }}</span>
        </div>
        @for (segment of group.rows; track segment.label) {
          <button
            type="button"
            class="flex w-full items-center gap-2.5 rounded-lg px-2 py-1.5 text-left transition-opacity"
            [attr.data-testid]="'legend-' + segment.label"
            [style.opacity]="highlighted() && !isHighlighted(segment.label) ? 0.4 : 1"
            (mouseenter)="hovered.set(segment.label)"
            (mouseleave)="hovered.set(null)"
            (click)="segmentFilterClick.emit(segment.label)"
          >
            <span class="h-2.5 w-2.5 rounded-full" [style.background]="segment.color"></span>
            <span class="flex-1 text-sm">{{ labelKey(segment.label) | translate }}</span>
            <span class="text-sm font-bold">{{ segment.value }}</span>
          </button>
        }
      }
      <hr class="my-2 border-t" />
      <div
        class="flex items-center px-2 text-xs font-bold uppercase tracking-wider text-text-muted"
        data-testid="legend-total"
      >
        <span class="flex-1">{{ 'home.devicesWidget.total' | translate }}</span>
        <span>{{ total() }}</span>
      </div>
    </div>
  </div>
</xemex-card>
